export const Menu = {
  parts: ['list', 'item'],
  baseStyle: {
    list: {
      boxShadow: 'lg',
      rounded: 'md',
      flexDirection: 'column',
      bg: 'brand.front',
      borderColor: 'brand.border',
      py: '2'
    },
    item: {
      fontWeight: 'medium',
      lineHeight: 'normal',
      color: 'brand.text',
      _hover: {
        bg: 'brand.hover',
        color: 'brand.text'
      },
      _focus: {
        bg: 'brand.hover'
      },
      _active: {
        bg: 'brand.hover'
      }
    }
  }
}
